import {
  ENVIRONMENT,
  GIT_BRANCH,
  GIT_SHA1,
  IS_PROD,
  SLACK_HOOK_URL,
} from "@/globals";

export function sendWarningMessage(
  text: string,
  channel?: string,
  botname?: string,
  iconEmoji?: string
): void {
  if (!SLACK_HOOK_URL) {
    console.warn(
      "[slack] SLACK_HOOK_URL is not set, skipping warning message:",
      text
    );
    return;
  }
  void fetch(SLACK_HOOK_URL, {
    method: "POST",
    body: JSON.stringify({
      channel: channel || "#web-logs",
      username: `${botname || "webhookbot"}[${ENVIRONMENT}] (${GIT_BRANCH}@${GIT_SHA1})`,
      text,
      icon_emoji: iconEmoji || ":warning:",
    }),
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    credentials: "same-origin",
  });
}

export function sendDebugMessage(user: {
  _id: string;
  username: string;
  type: string;
}): void {
  const text =
    `:beetle: *Debug info triggered by \`${user.username}\`*\n` +
    `• User ID: \`${user._id}\`\n` +
    `• Type: \`${user.type}\`\n` +
    `• URL: \`${window.location.href}\`\n` +
    `• User agent: \`${navigator.userAgent}\`\n` +
    `• Screen: \`${window.screen.width}x${window.screen.height}\` (viewport: \`${window.innerWidth}x${window.innerHeight}\`)`;
  sendWarningMessage(text, "#web-logs", "debug-bot", ":beetle:");
}

export function sendAPIErrorMessage(
  text: string,
  channel?: string,
  botname?: string,
  iconEmoji?: string
): void {
  if (!SLACK_HOOK_URL) {
    console.warn(
      "[slack] SLACK_HOOK_URL is not set, skipping API error message:",
      text
    );
    return;
  }
  void fetch(SLACK_HOOK_URL, {
    method: "POST",
    body: JSON.stringify({
      channel: channel || `#web-logs-api-${IS_PROD ? "prod" : "dev"}`,
      username: `${botname || "inspector"}[${ENVIRONMENT}] (${GIT_BRANCH}@${GIT_SHA1})`,
      text,
      icon_emoji: iconEmoji || ":male-detective:",
    }),
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    credentials: "same-origin",
  });
}
